export default __webpack_public_path__ + "static/media/faten.bd88a54d.png";